import React from 'react';
import { Button, Tooltip } from '@mui/material';
import { SvgIcon } from '@mui/material';
import getMuiIcon from '../../../../utils/getMuiIcon';
import { palette, boxShadows, spaces } from '../../../../assets/styles/themes/tokens';
import { useTranslation } from 'react-i18next';

interface AIAssistantChatCollapseButtonProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

const buttonStyles = {
  position: 'absolute',
  right: '0px',
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 10,
  borderRadius: '100px',
  background: palette.background.paperElevation0,
  boxShadow: boxShadows.elevation26,
  display: 'flex',
  padding: spaces.xs,
  alignItems: 'center',
  cursor: 'pointer',
  minWidth: 'auto',
  '&:hover': {
    background: palette.background.paperElevation0,
    boxShadow: boxShadows.elevation26,
  },
};

const iconStyles = {
  display: 'flex',
  width: '24px',
  height: '24px',
  justifyContent: 'center',
  alignItems: 'center',
  color: palette.primary.main,
};
const AIAssistantChatCollapseButton: React.FC<AIAssistantChatCollapseButtonProps> = ({ isCollapsed, onToggle }) => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleToggle = () => {
    handleClose();
    onToggle();
  };

  const tooltipTitle = isCollapsed ? t('Open muki') : t('Collapse muki');
  const tooltipPlacement = isCollapsed ? 'left' : 'right';

  return (
    <Tooltip 
      title={tooltipTitle} 
      placement={tooltipPlacement} 
      arrow
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      disableFocusListener
      disableTouchListener
    >
      <Button
        data-testid='chat-collapse-button'
        sx={buttonStyles}
        onClick={handleToggle}
        aria-label={isCollapsed ? 'Expand chat' : 'Collapse chat'}
      >
        <SvgIcon
          component={getMuiIcon(isCollapsed ? 'arrowLeft' : 'arrowRight')}
          sx={iconStyles}
        />
      </Button>
    </Tooltip>
  );
};

export default AIAssistantChatCollapseButton;

